import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Avatar, Box, Button, Card, CardActions, Divider, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { Chart } from '../../chart';

export const OportunidadesVentasDinero = (props) => {
  const { oportunidades = [], date = new Date() } = props;
  const [total, setTotal] = useState(0);
  const [totalCompleted, setTotalCompleted] = useState(0);
  const [porcentajeTotal, setPorcentajeTotal] = useState(0);
  const [porcentajeTotalCompleted, setPorcentajeTotalCompleted] = useState(0);
  const theme = useTheme();

  // Sumar el oportunidades.value de cada oportunidad
  // El value es el monto de la oportunidad y viene en el formato de moneda: 1,699,500.00
  const sumarTotal = () => {
    let total = 0;
    oportunidades.forEach(oportunidad => {
      // Solo no sumar si status es "cancelled"
      if (oportunidad.status !== 'cancelled') {
        total += parseFloat(oportunidad.value.replace(/,/g, ''));
      }
    });
    setTotal(total);

    let totalCompleted = 0;
    // Sumar los que tienen un status de "delivered", "paid" o "deposit"
    oportunidades.forEach(oportunidad => {
      if (oportunidad.status === 'delivered' || oportunidad.status === 'paid' || oportunidad.status === 'deposit') {
        totalCompleted += parseFloat(oportunidad.value.replace(/,/g, ''));
      }
    });
    setTotalCompleted(totalCompleted);

    // Calcular el porcentaje de ventas completadas
    setPorcentajeTotalCompleted((totalCompleted / total) * 100);
    // Calcular el porcentaje de ventas en proceso
    setPorcentajeTotal(((total - totalCompleted) / total) * 100);
  }

  useEffect(() => {
    sumarTotal();
  }, [oportunidades]);

  const chartOptions = {
    chart: {
      background: 'transparent',
      stacked: false,
      toolbar: {
        show: false
      }
    },
    colors: [theme.palette.secondary.light],
    fill: {
      opacity: 1
    },
    labels: [],
    plotOptions: {
      radialBar: {
        dataLabels: {
          show: false
        },
        hollow: {
          size: '40%'
        },
        track: {
          background: theme.palette.secondary.dark
        }
      }
    },
    theme: {
      mode: theme.palette.mode
    }
  };

  return (
    <Card {...props}
      style={{
        marginTop: '10px',
        marginBottom: '10px',
      }}
    >
      <Box
        sx={{
          alignItems: {
            sm: 'center'
          },
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: {
            xs: 'column',
            sm: 'row'
          }
        }}
      >
        <Chart
          height={200}
          options={chartOptions}
          series={[porcentajeTotalCompleted]}
          type="radialBar"
          width={200}
        />
        <Box
          sx={{
            display: 'flex',
            flexGrow: 1,
            pt: {
              sm: 3
            },
            pb: 3,
            pr: 4,
            pl: {
              xs: 4,
              sm: 0
            }
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              mr: 3
            }}
          >
            <Typography
              color="secondary"
              variant="h3"
            >
              { // Formatear el numero a moneda
                new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(totalCompleted)
              }
            </Typography>
            <Typography
              color="textSecondary"
              variant="body2"
            >
              En ventas completadas de un total de
            </Typography>
            {
              total !== totalCompleted && (
                <>
                  <Typography
                    color="textSecondary"
                    variant="h6"
                  >
                    { // Formatear el numero a moneda
                      new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total)
                    }
                  </Typography>
                  <Typography
                    color="textSecondary"
                    variant="body2"
                  >
                    en ventas esperadas
                  </Typography>
                </>
              )
            }
          </Box>
        </Box>
      </Box>
    </Card>
  );
};

OportunidadesVentasDinero.propTypes = {
  oportunidades: PropTypes.array.isRequired,
  date: PropTypes.instanceOf(Date).isRequired
};